import { PaymentFrequency, PaymentMethod } from '../../core/reducers/financialCalculators';
export const tabType = {
    finance: 'finance',
    lease: 'lease',
    rebate: 'rebate',
};
export const tabTypeToPaymentMethodMap = {
    [tabType.finance]: PaymentMethod.finance,
    [tabType.lease]: PaymentMethod.lease,
    [tabType.rebate]: PaymentMethod.cash,
};
export const variants = {
    variant1: 'variant1',
    variant2: 'variant2',
    variant3: 'variant3',
    variant4: 'variant4',
    variant5: 'variant5',
};
export const { variant1, variant2, variant3, variant4, variant5 } = variants;
/*
Stackable offers:

Customer Incentive Dollars
Trading Dollars
AFS Loyalty Dollars
Cash or Maintenance Package
CRM Dollars
Lease Bonus
Finance Bonus
Special Sales Event (3-day sale)

Non-stackable offers:
Non-Stackable Trading Dollar (NSTD)
Lease NSTD
Finance NSTD
*/
export const offerType = {
    customerIncentiveDollars: 'Customer Incentive Dollars',
    customerCashRebate: 'Customer Cash Rebate',
    tradingDollars: 'Trading Dollars',
    afsLoyaltyDollars: 'AFS Loyalty Dollars',
    cashOrMaintenancePackage: 'Cash or Maintenance Package',
    crmDollars: 'CRM Dollars',
    leaseBonus: 'Lease Bonus',
    financeBonus: 'Finance Bonus',
    specialSalesEvent: 'Special Sales Event (3-day sale)',
    nonStackableTradingDollar: 'Non-Stackable Trading Dollar (NSTD)',
    leaseNSTD: 'Lease NSTD',
    financeNSTD: 'Finance NSTD',
};
export { PaymentFrequency, PaymentMethod };
